/* eslint-disable */
import { apiClient } from "./api";
import { consultaPaciente, PacienteLight } from "@/interfaces/pacienteInterfaces";
import { DatosPaciente } from "@/interfaces/pacienteInterfaces";
import { isAxiosError } from "axios";

class PacienteService {
  private basicURL: string;
  private osURL: string;

  constructor() {
    this.basicURL = "/Paciente";
    this.osURL = "/ObraSocial";
  }

  async getPaciente(datos: DatosPaciente){
    const endpoint = `${this.basicURL}/ValidarPaciente`;
    var fac = localStorage.getItem('facturador');
    const body: string = JSON.stringify
    ({
      obraSocial: datos.obraSocial.nombre,
      tipoDocumento: datos.tipoDocumento,
      numeroDocumento: datos.numeroDocumento,
      sexo: datos.sexo,
      token: datos.token,
      username: datos.username,
      numeroAfiliado: datos.numeroAfiliado,
      nroTransaccion: datos.nroTransaccion,
      facturadorId: fac ? JSON.parse(fac).id : '0',
      // carnetAfiliado: datos.carnetAfiliado,
      // vencimientoCarnet: datos.vencimientoCarnet,
    });
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al validar el paciente";
    }
  }

  async postDatosAdicionales(paciente: PacienteLight){
    const endpoint = `${this.basicURL}/CargarDatosAdicionales`;
    const body: string = JSON.stringify(paciente);//Enviar todos los datos del paciente
    // const body: string = JSON.stringify(datos); preguntar a cata si puedo enviar id en vez de pacienteId y si necesita el nroTransaccion.
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al validar el paciente";
    }
  }

  async getPacientesConReintegros(){
    const endpoint = `${this.basicURL}/GetPacientesConReintegros`;
    try {
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al validar el paciente";
    }
  }

  async getPlanesObraSocial(obraSocialId: number){
    const endpoint = `${this.osURL}/GetPlanesObraSocial`;
    const body = {
      id: obraSocialId,
    };
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al validar el paciente";
    }
  }
  
  async getGrupos(){
    const endpoint = `${this.osURL}/GetGrupos`;
    try {
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al validar el paciente";
    }
  }

  async getTiposServicio(){
    const endpoint = `${this.osURL}/GetTiposDeServicio`;
    try {
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error : unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      return "Error al validar el paciente";
    }
  }

  // Metodos viejos:
  async findPaciente(token: string) {
    const endpoint = `${this.basicURL}/SearchPacienteLocalConEmail`;
    const body = {
      token: token,
    };
    try {
      const response = await apiClient.post(endpoint, body);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
      } else {
        console.error("Unknown error occurred");
      }
    }
  }

  async checkPaciente(token: string, especialidad: string) {
    const endpoint = `${this.basicURL}/CheckPacienteReserva`;
    const body = {
      token: token,
      especialidad: especialidad,
    };
    try {
      const response = await apiClient.post(endpoint, body);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async getObrasSocialesTotales(){
    const endpoint = `${this.osURL}/GetObrasSocialesTotales`;
    try {
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      console.error("Error al obtener las obras sociales totales", error);
      return "Error al obtener las obras sociales totales";
    }
  }

  async getBandejasAutorizacion(){
    const endpoint = `${this.osURL}/GetBandejasAutorizacion`;
    try {
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      console.error("Error al obtener las bandejas de autorizacion", error);
      return "Error al obtener las bandejas de autorizacion";
    }
  }

  async getCantidadesAnualesPracticaAfiliado(practicaId: string, numeroAfiliado: string, obraSocial: string) {
    const endpoint = `${this.basicURL}/GetCantidadesAnualesPracticaAfiliado`;
    const body = {
      idSolicitudPractica: practicaId,
      nroAfiliado: numeroAfiliado,
      obraSocial: obraSocial
    };
    try {
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        return error.response;
      }
      console.error("Error al obtener las cantidades anuales de la practica del afiliado", error);
      return "Error al obtener las cantidades anuales de la practica del afiliado";
    }
  }

  async getConfiguracionesObrasSociales(){
    const endpoint = `${this.osURL}/GetConfiguracionesObrasSociales`;
    try {
        const response = await apiClient.get(endpoint);
        return response;
    } catch (error: unknown) {
        if (error instanceof Error) {
            console.error(error.message);
            return error;
        } else {
            console.error("Unknown error occurred");
            return error;
        }
    }
  }
}
export default PacienteService;
